import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from './fetcher/fetcher.service';
import { GetProductsByParamsResponsePayload } from '@cpak/adp-cpak-bff-service-models';
import { LocationTypes } from '@cpak/adp-cpak-quotes-service-models';

@Injectable({
  providedIn: 'root',
})
export class GetProductsByCatalogNumberService {
  constructor(private fetcher: FetcherService) {}

  public getProductsByCatalogNumber(
    catalogNumber: string,
    countryId: string,
    quoteProductTypeId: string,
    locationType?: LocationTypes
  ): Observable<GetProductsByParamsResponsePayload | null> {
    return this.fetcher.get<GetProductsByParamsResponsePayload>(`/api/pages/catalog/products`, {
      catalogNumber,
      countryIds: countryId,
      quoteProductId: quoteProductTypeId,
      ...(locationType && { locationType }),
    });
  }
}
